(function () {
  // 1) Predictive (dropdown) search: limit to title + tags (documented param for the suggest endpoint)
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && url.indexOf('/search/suggest') > -1 && url.indexOf('resources[options][fields]') === -1) {
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'resources[options][fields]=title,tag';
        input = typeof input === 'string' ? url : new Request(url, input);
      }
    } catch (e) {}
    return origFetch.call(this, input, init);
  };

  // 2) Search results page
  if (!/\/search\/?$/.test(location.pathname)) return;
  var p = new URLSearchParams(location.search);
  var q = (p.get('q') || '').replace(/["']/g, '').trim();
  if (!q) return;

  // Matches the queries this script builds, e.g. "title:x OR tag:x OR variants.sku:x"
  var OURS = /^(\(?title:[^\s()]+ OR tag:[^\s()]+ OR variants\.sku:[^\s()]+\)?\s*)+$/;
  var isOurs = OURS.test(q);

  // Turn a built query back into what the customer typed
  function plain(s) {
    var seen = {}, out = [];
    s.replace(/[()]/g, ' ').replace(/\b(title|tag|variants\.sku):/g, '').split(/\s+/).forEach(function (t) {
      var k = t.toLowerCase();
      if (t && t !== 'OR' && !seen[k]) { seen[k] = 1; out.push(t); }
    });
    return out.join(' ');
  }

  // Plain word search -> title OR tag OR sku (no fallback to a full-text search)
  if (!isOurs) {
    if (/\w+:/.test(q)) return; // customer/admin already used field syntax; leave it alone
    var words = q.replace(/[()]/g, ' ').split(/\s+/).filter(Boolean);
    var built = words.map(function (w) {
      var c = '(title:' + w + ' OR tag:' + w + ' OR variants.sku:' + w + ')';
      return words.length === 1 ? c.slice(1, -1) : c;
    }).join(' ');
    p.set('q', built);
    p.delete('full');
    if (!p.has('type')) p.set('type', 'product');
    location.replace(location.pathname + '?' + p.toString());
    return;
  }

  // Hide the raw query text until it has been cleaned, so "title:..." never flashes
  var hideStyle = document.createElement('style');
  hideStyle.textContent = '.main-page-title,.search__form-text,input[name="q"]{visibility:hidden!important}';
  (document.head || document.documentElement).appendChild(hideStyle);
  function reveal() {
    if (hideStyle && hideStyle.parentNode) hideStyle.parentNode.removeChild(hideStyle);
    hideStyle = null;
  }
  setTimeout(reveal, 2500); // safety: never leave the text hidden

  function clean() {
    var shown = plain(q);
    document.querySelectorAll('.main-page-title, .search__form-text').forEach(function (el) {
      if (el.textContent.indexOf('title:') > -1) el.textContent = el.textContent.split(q).join(shown);
    });
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.value.indexOf('title:') > -1) i.value = shown;
    });
  }

  document.addEventListener('DOMContentLoaded', function () { clean(); reveal(); });
  window.addEventListener('pageshow', function () { clean(); reveal(); });
})();